// eslint-disable-next-line prefer-const, import/no-mutable-exports -- Allow commented code to override
export let showUnfinishedFeatures =
  process.env.NODE_ENV === 'development' || process.env.REACT_APP_SITE_URL === 'https://fund-stg.givewise.ca'
// eslint-disable-next-line prefer-const, import/no-mutable-exports
export let onlyShowInDev = process.env.NODE_ENV === 'development'

// Uncomment the following to test production behaviour of the UI in development
// showUnfinishedFeatures = false
// onlyShowInDev = false

export const isInDevOrForImpersonatorsInProd = () => {
  const storedState = localStorage.getItem('givewise_auth_state')

  let isImpersonating = false

  if (storedState) {
    const parsedState = JSON.parse(storedState)
    const stack = parsedState.state.impersonatorTokenStack
    isImpersonating = Array.isArray(stack) && stack.length > 0
  }
  return showUnfinishedFeatures || isImpersonating
}
